export default {
  common: {
    title: 'System Zarządzania Logistyką',
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
    submit: 'Wyślij',
    reset: 'Resetuj',
    search: 'Szukaj',
    add: 'Dodaj',
    edit: 'Edytuj',
    delete: 'Usuń',
    save: 'Zapisz',
    back: 'Wstecz',
    operation: 'Operacja',
    status: 'Status',
    createTime: 'Czas utworzenia',
    updateTime: 'Czas aktualizacji'
  },
  message: {
    success: 'Operacja zakończona sukcesem',
    error: 'Operacja nie powiodła się',
    warning: 'Ostrzeżenie',
    info: 'Informacja',
    confirmDelete: 'Na pewno usunąć?'
  },
  login: {
    title: 'Logowanie',
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    loginBtn: 'Zaloguj się'
  },
  language: {
    language: 'Język',
    german: 'Niemiecki',
    english: 'Angielski',
    chinese: 'Chiński',
    polish: 'Polski'
  },
  nav: {
    home: 'Strona główna',
    about: 'O nas',
    services: 'Usługi',
    blog: 'Blog',
    contact: 'Kontakt'
  },
  banner: {
    title1: 'Najlepsze rozwiązanie transportowe na świecie',
    text1: 'Wiele tras międzynarodowych, bezpośredni transport lotniczy. Maksymalne rabaty logistyczne, przejrzyste opłaty, brak ukrytych kosztów.',
    title2: 'Najlepsze rozwiązanie transportowe na świecie',
    text2: 'Dzięki precyzyjnym procesom efektywność jest o 30%-40% wyższa niż u konkurentów. Korzystaj na żądanie, możliwość rozbudowy w każdej chwili, bez problemów magazynowych w sezonie szczytowym.',
    title3: 'Lider globalnych usług logistycznych',
    text3: 'Uproszczenie handlu międzynarodowego.',
    requestQuote: 'Poproś o wycenę'
  },
  tracking: {
    placeholder: 'Wprowadź numer śledzenia przesyłki',
    query: 'Szukaj',
    title: 'Informacje logistyczne',
    noInfo: 'Brak informacji',
    trackingNumber: 'Numer śledzenia',
    loading: 'Ładowanie danych logistycznych...',
    customerName: 'Odbiorca',
    mobile: 'Telefon',
    address: 'Adres',
    goodsName: 'Nazwa towaru',
    timelineTitle: 'Postęp przesyłki'
  },
  services: {
    title: 'Usługi',
    subtitle: 'Obsługa sprzedawców e-commerce cross-border',
    description: 'Nie martw się o dostawę, zamówienia zostaną przetworzone na czas.',
    landTransport: 'Transport lądowy',
    landTransportDesc: 'Najniższe rabaty na ekspres międzynarodowy, DHL, UPS oraz przesyłki pocztowe – korzystaj z najlepszych cen.',
    airFreight: 'Transport lotniczy',
    airFreightDesc: 'Oferuje różne bezpośrednie połączenia lotnicze do Ameryki, Europy, Japonii i innych regionów.',
    warehouse: 'Magazyn',
    warehouseDesc: 'Bezpłatne magazynowanie, jednorazowe zlecenie, składowanie, wysyłka, pakowanie i etykietowanie.',
    seaFreight: 'Transport morski',
    seaFreightDesc: 'Integracja wysokiej jakości zasobów żeglugowych z Hongkongu dla globalnej żeglugi.',
    homeDelivery: 'Dostawa do domu',
    homeDeliveryDesc: 'Wystarczy uiścić określoną opłatę logistyczną, a dostarczymy towar prosto do domu.',
    support24x7: 'Wsparcie 24/7',
    support24x7Desc: 'Lata doświadczeń w obsłudze e-commerce cross-border, całodobowa obsługa klienta, brak barier czasowych.',
    readMore: 'Dowiedz się więcej',
    bestServices: 'Nasze najlepsze usługi',
    bestServicesSubtitle: 'Obsługujemy firmy, sklepy i osoby działające w e-commerce transgranicznym.',
    internationalShipping: 'Transport międzynarodowy',
    internationalShippingDesc: 'Największe zniżki na koszty logistyczne, pomagamy oszczędzać na transporcie.',
    packageProtection: 'Ochrona przesyłek',
    packageProtectionDesc: 'Dropshipping, sortowanie i pakowanie, druk i etykietowanie zamówień, oszczędność kosztów pracy.',
    freightSupport: 'Wsparcie frachtowe',
    freightSupportDesc: 'Wsparcie frachtowe',
    onTimeDelivery: 'Dostawa na czas',
    onTimeDeliveryDesc: 'Wydajność operacyjna o 30% - 40% wyższa niż u konkurencji, niska liczba błędów i doskonałe doświadczenie użytkownika.',
    logisticsWork: 'Praca logistyczna',
    logisticsWorkDesc: 'Bezpłatne API do efektywnego zarządzania magazynem, towarami, zamówieniami i informacjami logistycznymi.',
    supportDesc: 'Elastyczne wykorzystanie przestrzeni magazynowej pomaga uniknąć pustych magazynów poza sezonem i przepełnienia w szczycie.',
    exploreAll: 'Poznaj wszystkie usługi'
  },
  about: {
    title: 'O nas',
    mainTitle: 'Cyfrowa i godna zaufania firma transportowa',
    description: 'GG to nowy model usług magazynowych opracowany specjalnie dla e-commerce nastawionego na eksport, oparty na zarządzaniu internetowym.',
    point1: 'Klienci dostarczają towary do chmury magazynowej partiami;',
    point2: 'GG sortuje, pakuje, drukuje i etykietuje towary bezpośrednio z chmurowego magazynu na podstawie zamówień i realizuje transport i dystrybucję;',
    description2: 'Chmurowy magazyn GG Enterprise to kompleksowa usługa łańcucha dostaw integrująca zarządzanie magazynem, transport międzynarodowy, odprawę celną i zarządzanie informacją. Pomaga przełamać wąskie gardła logistyczne, obniżyć koszty, zwiększyć satysfakcję klientów i zdobywać rynki zagraniczne.',
    experience: 'Posiadamy wieloletnie doświadczenie',
    readMore: 'Dowiedz się więcej',
    contact: 'Kontakt'
  },
  choose: {
    title: 'Dlaczego my',
    mainTitle: 'Zapewniamy szybkie i lepsze rozwiązania transportowe',
    description: 'Chmurowy magazyn Global Goods Enterprise to nowy model usług magazynowych stworzony dla eksportowego e-commerce, oparty na zarządzaniu internetowym. Zapewnia kompleksowe rozwiązania obejmujące magazynowanie, sortowanie i pakowanie, druk dokumentów i etykiet, logistykę międzynarodową oraz dystrybucję zagraniczną, jednocześnie oferując bardzo niskie koszty transportu. Pomaga przełamać bariery logistyczne, obniżyć koszty, zwiększyć satysfakcję klientów i rozwijać rynki zagraniczne.',
    internationalShipping: 'Transport międzynarodowy',
    packageProtection: 'Ochrona przesyłek',
    homeDelivery: 'Dostawa do domu',
    deliveryTime: 'Czas dostawy',
    contact: 'Kontakt'
  },
  team: {
    title: 'Nasz zespół',
    description: 'Wszyscy tak mówią, ale u nas to prawda: nasz zespół to tajemnica naszego sukcesu. Każdy pracownik jest znakomity, lecz razem tworzą klucz do tego, że Rostrum to tak interesujące i wartościowe miejsce pracy. Zespół Rostrum to zgrana, utalentowana grupa ze wspólną wizją dostarczania wybitnych rezultatów dla klientów, dbając jednocześnie o przyjazne, integracyjne i wymagające środowisko oraz bogate możliwości rozwoju kariery.',
    follow: 'Obserwuj'
  },
  gallery: {
    title: 'Nasza galeria',
    description: 'Global Goods prowadzi szeroko zakrojoną działalność na całym świecie, a jej sześć obszarów biznesowych, jedna inicjatywa i organizacje regionalne ściśle współpracują. Poprzez strategiczną i organiczną integrację solidnych fundamentów i różnorodnych funkcji tworzymy nową wartość, proaktywnie reagując na zmiany i wykraczając poza schematy, aby pomagać w rozwiązywaniu problemów społecznych.',
    all: 'Wszystko',
    airFreight: 'Transport lotniczy',
    waterFreight: 'Transport wodny',
    shipping: 'Transport morski',
    shippingTitle: 'Transport',
    expertTeam: 'Zespół ekspertów',
    expertMember: 'Ekspert',
    carTransport: 'Transport samochodowy',
    seaport: 'Port morski',
    container: 'Kontener',
    packaging: 'Pakowanie'
  },
  funfact: {
    productDelivery: 'Dostarczone produkty',
    totalBranches: 'Liczba oddziałów',
    satisfiedCustomers: 'Zadowoleni klienci',
    ownVehicles: 'Własne pojazdy'
  },
  blog: {
    title: 'Najnowsze wiadomości i blog',
    description: 'Znajdź najnowsze wiadomości blogowe z WIRED. Zobacz powiązane artykuły, zdjęcia, prezentacje i filmy.',
    readMore: 'Czytaj więcej',
    comments: 'Komentarze',
    title1: 'Transport lotniczy może być drogi podczas pandemii',
    excerpt1: 'Drastycznie zmniejszona przepustowość i pilne zapotrzebowanie na środki ochrony podniosły ceny usług lotniczych...',
    title2: 'Nowa usługa frachtowa otwarta na rynku globalnym',
    excerpt2: 'Na szczycie tego rynku globalni spedytorzy muszą utrzymywać elastyczne podejście do transportu towarów. Pozostań otwarty na nowości...',
    title3: 'Opłaty transportowe zostały zniesione',
    excerpt3: 'Ze względu na bezpośredni wpływ transportu na sukces gospodarczy rządy tradycyjnie bardziej angażują się w praktyki spedytorów niż zwykle...'
  },
  transport: {
    title: 'Transport',
    mainTitle: 'Dostarczamy towary wszędzie',
    description: 'Czas referencyjny: odnosi się do normalnego czasu transportu towarów. Na podstawie analiz big data większość paczek może ulec opóźnieniu z powodu pogody, kontroli celnych, korków w portach, przeciążenia magazynów i innych problemów, od momentu zapytania w systemie aż do dotarcia do celu. Dokładna sytuacja zależy od rzeczywistego transportu.',
    requestQuote: 'Poproś o wycenę',
    formTitle: 'Poproś o wycenę',
    name: 'Imię i nazwisko',
    request: 'Poproś o wycenę',
    length: 'Długość (CM)',
    width: 'Szerokość (CM)',
    weight: 'Waga (KG)',
    distance: 'Dystans (KM)',
    city: 'Miasto',
    transportType: 'Rodzaj transportu',
    airFreight: 'Transport lotniczy',
    roadTransport: 'Transport drogowy',
    railTransport: 'Transport kolejowy',
    seaFreight: 'Transport morski',
    submit: 'Wyślij teraz',
    contact: 'Kontakt'
  },
  newsletter: {
    title: 'Bądź na bieżąco z naszym newsletterem',
    placeholder: 'Wpisz adres e-mail',
    subscribe: 'Subskrybuj'
  },
  footer: {
    followUs: 'Śledź nas',
    quickLinks: 'Szybkie linki',
    about: 'O nas',
    services: 'Usługi',
    currentWork: 'Aktualne projekty',
    expertTeam: 'Zespół ekspertów',
    newsBlog: 'Wiadomości i blog',
    support: 'Wsparcie',
    faqs: 'FAQ',
    pricing: 'Cennik',
    privacyPolicy: 'Polityka prywatności',
    terms: 'Regulamin',
    globalLocations: 'Globalne lokalizacje',
    partners: 'Nasi partnerzy',
    copyright: 'Copyright @2024 fairy. Designed By',
    menu: 'Menu'
  }
}

